import React from 'react';
export function AdvertorialHeader() {
  return <header className="bg-[#2B7FD9] text-white w-full sticky top-0 z-50 shadow-md" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-center" data-id="element-42">
        <div className="flex items-center gap-2" data-id="element-43">
          <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-[#2B7FD9] font-bold text-xl" data-id="element-44">
            B
          </div>
          <span className="font-sans font-bold text-xl tracking-tight" data-id="element-45">
            Barkvee Health
          </span>
        </div>
      </div>
    </header>;
}